module.exports = __webpack_public_path__ + "static/img/card_openpay.6e404d2b.png";